const Footer = () => {
  return (
    <footer className="absolute bottom-10 w-full text-center text-sm md:text-base">
      Copyright &copy; 2023 YongjaeHyun. All rights reserved.
    </footer>
  );
};

export default Footer;
